import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { setupPWA } from '@/lib/pwa'

setupPWA()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
